/**
 * In-note medication detection contracts (GRO-3933 / GRO-3934).
 * BE: domains/medication_detection/api/v2/schemas.py
 */

export type MedicationNameType = 'generic' | 'brand' | 'local' | 'unknown';

export interface MedicationDetection {
  matched_text: string;
  normalized_name: string;
  span_start: number;
  span_end: number;
  name_type?: MedicationNameType | null;
}

export type MedicationDetectionStatus = 'pending' | 'completed' | 'failed';

export interface MedicationDetectionRunResponse {
  run_id: string;
  session_id: string;
  consult_note_id?: string | null;
  status: MedicationDetectionStatus;
  failure_reason?: string | null;
  detections: MedicationDetection[];
  created_at: string;
  completed_at?: string | null;
}

/** True when BE finished (including zero detections). False while in-flight or not yet started. */
export function isMedicationDetectionRunComplete(data: {
  status?: MedicationDetectionStatus;
  detections: MedicationDetection[];
}): boolean {
  if (data.detections.length > 0) return true;
  return data.status === 'completed' || data.status === 'failed';
}

export interface StartAutoMedicationDetectionResponse {
  run_id: string;
  session_id: string;
  status: MedicationDetectionStatus;
}
